import { Pipe, PipeTransform } from '@angular/core';
import { Student } from '../models/student';
import { StudentRegistration } from '../models/student-registration';

@Pipe({ name: 'address' })
export class AddressPipe implements PipeTransform {
  transform(student: Student | StudentRegistration): string {
    let result = `${student.street} ${student.house}, ${student.zip} ${student.city}`;
    return result.trim() === '0,' ? '' : result;
  }
}
